module.exports = __webpack_public_path__ + "static/img/14179bc4.svg";